function createResizer(gantt, grid){
	return {
		init: function(){},
		doOnRender: function(){}
	};
}

export default createResizer;